export const RunStatus = {
    RUN_STARTED : "RUN_STARTED",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED : "COMPLETED"
}

export const RunProcessStep = {
    CREATE_RUN : "CREATE_RUN" 
}